(function () {
  var config = window.__currencyConfig;
  if (!config || !config.rate || isNaN(config.rate)) return;

  var rate = config.rate;
  var sym = config.symbol;
  var dec = config.decimals;
  var gap = config.space ? ' ' : '';

  function fmt(paise) {
    var amount = (paise / 100) / rate;
    var out;
    if (dec === 0) {
      out = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      var parts = amount.toFixed(dec).split('.');
      out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    }
    return sym + gap + out;
  }

  function convert(el) {
    var p = parseInt(el.getAttribute('data-price-inr'), 10);
    if (p > 0) el.textContent = fmt(p);
  }

  function convertAll(root) {
    for (var els = (root || document).querySelectorAll('[data-price-inr]'), i = 0; i < els.length; i++) convert(els[i]);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var added = mutations[i].addedNodes, j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute('data-price-inr')) { convert(n); continue; }
        var children = n.querySelectorAll && n.querySelectorAll('[data-price-inr]');
        if (children) for (var k = 0; k < children.length; k++) convert(children[k]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  convertAll(document);
})();
